import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import React from 'react';
import ProgressiveImage from 'react-progressive-graceful-image';
import PropTypes from 'prop-types';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

const LazyLoadImage = ({
  src,
  alt,
  placeholder,
  loaderSize = 40,
  sx,
  ...props
}) => {
  if (!src) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f0f0f0',
          ...sx,
        }}
        {...props}
      >
        <QuestionMarkIcon color="#FFFFFF" fontSize="10px" />
      </Box>
    );
  }

  return (
    <ProgressiveImage src={src} placeholder={placeholder}>
      {(newSrc, loading) => (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
            flexShrink: 0,
            ...sx,
          }}
          {...props}
        >
          {loading ? (
            <CircularProgress
              id="progressive-image-loading"
              title="ProgressiveImage loading"
              size={loaderSize}
            />
          ) : (
            <Box
              component="img"
              src={newSrc}
              alt={alt}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          )}
        </Box>
      )}
    </ProgressiveImage>
  );
};

LazyLoadImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  placeholder: PropTypes.string,
  loaderSize: PropTypes.number,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

LazyLoadImage.defaultProps = {
  src: null,
  alt: '',
  placeholder: '',
  loaderSize: 40,
  sx: undefined,
};

export default React.memo(LazyLoadImage);
